import { Dispatch, SetStateAction } from 'react';
import { ace_index, loan_application } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function Product({ query, setQuery, editable = false }: Props) {
  const state = getProduct(query);
  const value = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setProduct(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Product"
      description="Filter by application type"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  { label: 'All', value: undefined },
  ...Object.values(loan_application.Product).map((product) => ({
    label: product,
    value: product,
  })),
];

function setProduct(product: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    ProductName: product,
  });
}

function getProduct(query: ace_index.FindInput) {
  return query.ProductName;
}

type Value = ace_index.FindInput['ProductName'];
